"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative overflow-hidden bg-primary py-24 px-6 !text-[hsl(0,0%,100%)] md:py-32">
      <div className={`mx-auto max-w-3xl text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <h2 className="mb-6 font-display text-4xl font-bold leading-tight text-foreground-primary md:text-5xl">
          Ready to Transform Your Space?
        </h2>
        <p className="mb-10 text-lg leading-relaxed text-foreground-primary/90 md:text-xl">
          Let our experienced team bring your vision to life with quality craftsmanship and attention to detail. Get your free estimate today.
        </p>
        <Link to="/ContactPage">
          <Button size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:shadow-strong">
            Request Free Estimate
          </Button>
        </Link>
      </div>
    </section>;
}